<nz-row nzGutter="16">
  <nz-col nzXl="12" nzLg="12" nzMd="12" nzSm="24" nzXs="24">
    <nz-input-group class="doc-search" nzSuffixIcon="search" *ngIf="showSearchInput">
      <input type="text" nz-input placeholder="Search..." autocomplete="false" [ngModel]="srv.searchValue"
             (keydown.enter)="search($any($event.target).value)" (blur)="search($any($event.target).value)" />
    </nz-input-group>
  </nz-col>
  <nz-col nzXl="12" nzLg="12" nzMd="12" nzSm="24" nzXs="24">
    <nz-space class="doc-actions float-right">
      <app-page-how-to-toolbar-btn></app-page-how-to-toolbar-btn>
      <button type="button" *ngIf="canCreate" type="button" nz-button nzType="primary" (click)="srv.gotoDetail('0')"
              [disabled]="srv.loading">
        Add
      </button>
      <ng-container *ngTemplateOutlet="extraActions">
      </ng-container>
      <button type="button" nz-button nz-dropdown [nzDropdownMenu]="more" nzPlacement="bottomRight"
              [disabled]="srv.loading">
        <span nz-icon nzType="ellipsis">
        </span>
      </button>
      @if (showFilterBtn && srv.transactionView !== 2) {
        <button nz-button type="button" nzType="link" (click)="filterVisible = true" class="doc-filter"
                [disabled]="srv.loading">
          <span nz-icon nzType="filter" nzTheme="outline"></span>
        </button>
      }
      <nz-dropdown-menu #more="nzDropdownMenu">
        <ul nz-menu>
          <li nz-menu-item (click)="onReload()" [nzDisabled]="srv.loading">Reload</li>
          <li nz-menu-item *ngIf="showMatchToAROR"
              [nzDisabled]="srv.selectedRows.length === 0 || srv.deleting || srv.loading"
              (click)="handleTransferToAROR()">
            Collect Payment
          </li>
          <li nz-menu-item *ngIf="showMatchToAPPV"
              [nzDisabled]="srv.selectedRows.length === 0 || srv.deleting || srv.loading"
              (click)="handleTransferToAPPV()">
            Add Payment
          </li>
          <li nz-menu-item *ngIf="showBulkApprove && srv.parkAndPost"
              [nzDisabled]="srv.selectedRows.length === 0 || srv.deleting || srv.loading"
              (click)="handleBulkApprove()">
            Approve
          </li>
          <li nz-menu-item *ngIf="canDelete" [nzDisabled]="srv.selectedRows.length === 0 || srv.deleting || srv.loading"
              (click)="srv.selectedRows.length === 0 || srv.deleting || srv.loading ? $event.stopPropagation() : handleDelete()"
              nzDanger>
            Delete
          </li>
          <ng-container *ngIf="moreActions?.length">
            <ng-container *ngFor="let item of moreActions">
              <li nz-menu-divider></li>
              <li nz-menu-item (click)="handleItemClick(item)"
                  *ngIf="!item.iif || item.iif() || item.iifBehavior === 'disabled'"
                  [nzDisabled]="item.iif && !item.iif() || srv.loading">
                {{ item.text }}
              </li>
            </ng-container>
          </ng-container>
        </ul>
      </nz-dropdown-menu>
      <!-- <span class="ml-sm">
        <app-list-view-switcher [(view)]="srv.transactionView" (viewChange)="onTransactionViewChange()" />
      </span> -->
    </nz-space>
  </nz-col>
</nz-row>
<nz-drawer [nzBodyStyle]="{ padding: '8px 24px' }" [nzClosable]="true" nzMaskClosable="true" [nzVisible]="filterVisible"
           nzPlacement="right" nzTitle="Filter" [nzExtra]="filterActions" (nzOnClose)="closeFilter()">
  <form nz-form *nzDrawerContent nzLayout="vertical">
    <div nz-row [nzGutter]="8">
      <div nz-col nzSpan="24">
        <nz-form-item>
          <nz-form-label>Doc Date</nz-form-label>
          <nz-form-control>
            <nz-range-picker name="period" [(ngModel)]="filter.period" nzDropdownClassName="customCalendar"
                             style="width: 100%"></nz-range-picker>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    @if (showStatus) {
      <div nz-row [nzGutter]="8">
        <div nz-col nzSpan="24">
          <nz-form-item>
            <nz-form-label>Status</nz-form-label>
            <nz-form-control>
              <nz-select name="status" class width nzMode="multiple" [nzDropdownMatchSelectWidth]="false"
                         [nzAllowClear]="true" [(ngModel)]="filter.status" (ngModelChange)="statusChange($event, 'DN')">
                <ng-container *ngFor="let o of transStatusOptions">
                  <nz-option [nzValue]="o.value" [nzLabel]="o.value" nzCustomContent>
                    <span> {{ o.label }}</span>
                  </nz-option>
                </ng-container>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    }

    @if (showAPStatus) {
      <div nz-row [nzGutter]="8">
        <div nz-col nzSpan="24">
          <nz-form-item>
            <nz-form-label>Status</nz-form-label>
            <nz-form-control>
              <nz-select name="status" class width nzMode="multiple" [nzDropdownMatchSelectWidth]="false"
                         [nzAllowClear]="true" [(ngModel)]="filter.status" (ngModelChange)="statusChange($event, 'CN')">
                <ng-container *ngFor="let o of apTransStatusOptions">
                  <nz-option [nzValue]="o.value" [nzLabel]="o.value" nzCustomContent>
                    <span> {{ o.label }}</span>
                  </nz-option>
                </ng-container>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    }

    @if (showEInvStatus) {
      <div nz-row [nzGutter]="8">
        <div nz-col nzSpan="24">
          <nz-form-item>
            <nz-form-label>e-Invoice Status</nz-form-label>
            <nz-form-control>
              <nz-select name="eInvStatus" class="width" nzMode="multiple" [nzDropdownMatchSelectWidth]="false"
                         [nzAllowClear]="true" [(ngModel)]="filter.eInvStatus">
                <ng-container *ngFor="let o of statusOption">
                  <nz-option [nzValue]="o.value" [nzLabel]="o.value" nzCustomContent>
                    <span> {{ o.label }}</span>
                  </nz-option>
                </ng-container>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    }

    @if (showEInvStatus) {
      <div nz-row [nzGutter]="8">
        <div nz-col nzSpan="24">
          <nz-form-item>
            <nz-form-label>Validation Control</nz-form-label>
            <nz-form-control>
              <nz-select name="eInvControl" class="width" nzMode="multiple" [nzDropdownMatchSelectWidth]="false"
                         [nzAllowClear]="true" [(ngModel)]="filter.eInvControl">

                @for (o of validationControls;
                  track o;
                  ) {
                  @if (!isSelfBilled || (isSelfBilled == o.selfBilled)) {
                    <nz-option [nzValue]="o.value" [nzLabel]="o.label" nzCustomContent>
                      <span> {{ o.label }}</span>
                    </nz-option>
                  }
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    }

    <nz-divider></nz-divider>
    <div nz-row>
      <button type="button" nz-button nzType="primary" (click)="submitFilter()">OK</button>
      <button type="button" nz-button nzType="default" (click)="resetFilter()" style="margin-left: 8px">Reset</button>
    </div>
  </form>
</nz-drawer>
<ng-template #filterActions>
</ng-template>
@if (emailStatusService.showEmailStatusModal()) {
  <app-email-status-modal [gridItems]="dxGrid?.instance?.getDataSource()?.items()" [docType]="$any(aclKey)" [customReportType]="srv.reportType()"
                          (close)="srv.closeEmailStatusModal()" />
}
